import { render, staticRenderFns } from "./ListQuizResponse.vue?vue&type=template&id=5efe134e&scoped=true&"
import script from "./ListQuizResponse.vue?vue&type=script&lang=js&"
export * from "./ListQuizResponse.vue?vue&type=script&lang=js&"
import style0 from "./ListQuizResponse.vue?vue&type=style&index=0&id=5efe134e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe134e",
  null
  
)

export default component.exports